import React from 'react';
import { Calendar, CheckCircle, XCircle, Dumbbell, Trophy } from 'lucide-react';

const DailyCheckIn = ({ onComplete }) => {
    const [step, setStep] = React.useState(1);

    const handleInitialResponse = (played) => {
        if (played) setStep(2);
        else onComplete({ played: false });
    };

    const handleActivitySelect = (type) => {
        onComplete({ played: true, type });
    };

    const renderInitialQuestion = () => (
        <div className="text-center animate-fadeIn">
            <Calendar size={48} className="mx-auto text-purple-500 mb-4" />
            <h2 className="text-2xl font-bold text-white mb-2">Did you play cricket today?</h2>
            <p className="text-gray-400 text-sm mb-6">Match, Nets, or Fitness?</p>

            <div className="space-y-3">
                <button
                    onClick={() => handleInitialResponse(true)}
                    className="w-full bg-gradient-to-r from-purple-600 to-blue-600 p-4 rounded-xl flex items-center justify-center gap-3 font-bold text-white hover:opacity-90 transition-opacity"
                >
                    <CheckCircle size={20} />
                    Yes, I trained / played
                </button>
                <button
                    onClick={() => handleInitialResponse(false)}
                    className="w-full bg-gray-800 p-4 rounded-xl flex items-center justify-center gap-3 font-medium text-gray-400 hover:bg-gray-700 transition-colors"
                >
                    <XCircle size={20} />
                    No, Rest Day
                </button>
            </div>
        </div>
    );

    const renderFollowUp = () => (
        <div className="text-center animate-fadeIn">
            <h2 className="text-xl font-bold text-white mb-6">What kind of day was it?</h2>
            <div className="space-y-3">
                <button
                    onClick={() => handleActivitySelect('match')}
                    className="w-full bg-gray-800 border border-green-500/30 p-4 rounded-xl flex items-center gap-4 hover:bg-gray-700 hover:border-green-500 transition-all text-left group"
                >
                    <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center text-green-500 group-hover:text-green-400">
                        <Trophy size={20} />
                    </div>
                    <div>
                        <h3 className="font-bold text-white">Match Day</h3>
                        <p className="text-xs text-gray-400">Log score & performance</p>
                    </div>
                </button>

                <button
                    onClick={() => handleActivitySelect('training')}
                    className="w-full bg-gray-800 border border-purple-500/30 p-4 rounded-xl flex items-center gap-4 hover:bg-gray-700 hover:border-purple-500 transition-all text-left group"
                >
                    <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-500 group-hover:text-purple-400">
                        <Dumbbell size={20} />
                    </div>
                    <div>
                        <h3 className="font-bold text-white">Training / Nets</h3>
                        <p className="text-xs text-gray-400">Log drills & focus</p>
                    </div>
                </button>
            </div>
        </div>
    );

    return (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50 p-6">
            <div className="bg-gray-900 border border-gray-800 w-full max-w-md p-6 rounded-2xl shadow-2xl relative">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 to-blue-500 rounded-t-2xl"></div>
                {step === 1 ? renderInitialQuestion() : renderFollowUp()}
            </div>
        </div>
    );
};

export default DailyCheckIn;
